import { render, staticRenderFns } from "./bookingTypesPage.vue?vue&type=template&id=709149ee&scoped=true"
import script from "./bookingTypesPage.vue?vue&type=script&lang=ts"
export * from "./bookingTypesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709149ee",
  null
  
)

export default component.exports